module.exports = __webpack_public_path__ + "img/disagree_fill.80e05071.svg";